// extracted by mini-css-extract-plugin
export default {"ctn":"Card_ctn__au6i3","question":"Card_question__fr0iD","choiceCtn":"Card_choiceCtn__Whasq"};